import React, { useState, useEffect } from 'react';
import { Link, useLocation } from "react-router-dom";
import { FaHome, FaSearch, FaShoppingCart, FaThLarge, FaUserCircle } from "react-icons/fa";
import { FiHeart, FiShoppingCart, FiUser } from "react-icons/fi";
import { HiOutlineShoppingCart, HiOutlineUser } from "react-icons/hi";
import Logo from "../assets/logo.png";
import Bottomlogo from "../assets/bottomlogo.png";
import { makeRequest } from "../services/api";
import { webEndPoint } from '../constants/globalConstants';
export default function Header() {
    const location = useLocation();
    const wishlistCount = 0;
    const cartCount = 0;
    const iconStyle = {
        strokeWidth: 1.5
    };
    const token = localStorage.getItem("userToken");
    const [loading, setLoading] = useState(false);
    const [cartData, setCartData] = useState([]);
    const [search, setSearch] = useState("");
    const [searchResults, setSearchResults] = useState([]);
    const [showSearch, setShowSearch] = useState(false);
    useEffect(() => {
        if (!token) {
            return;
        } else {
            fetchCartData();
        }
    }, []);
    const fetchCartData = async () => {
        setLoading(true);
        try {
            let url = webEndPoint + "cart/count/" + localStorage.getItem("userID");
            const response = await makeRequest("get", url);
            if (response) {
                setCartData(response.data);
                setLoading(false);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        if (!token) return;
        fetchCartData();
        const handleCartUpdate = () => {
            fetchCartData();
        };
        window.addEventListener("cartUpdated", handleCartUpdate);
        return () => {
            window.removeEventListener("cartUpdated", handleCartUpdate);
        };
    }, []);
    const searchProducts = async (value) => {
        setSearch(value);
        if (!value.trim()) {
            setSearchResults([]);
            setShowSearch(false);
            return;
        }
        try {
            const url = webEndPoint + "product/search?search=" + value;
            const response = await makeRequest("get", url);
            if (response?.data) {
                setSearchResults(response.data);
                setShowSearch(true);
            }
        } catch (err) {
            console.error(err);
        }
    };
    return (
        <>
            <header class="header desktop-header">
                <div class="logo"><a href="/"><img src={Logo}></img></a></div>
                <div class="search-bar"><input type="text" placeholder="Search products..." value={search} onChange={(e) => searchProducts(e.target.value)} />
                    <button><FaSearch color="white" size={16} /></button>
                    {showSearch && (
                        <div
                            style={{
                                position: "absolute",
                                top: "80px",
                                left: "51%",
                                transform: "translateX(-50%)",
                                width: "50%",
                                background: "#fff",
                                borderRadius: "10px",
                                boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
                                zIndex: 999,
                                maxHeight: "350px",
                                overflowY: "auto",
                            }}>
                            {searchResults.length > 0 ? (
                                searchResults.map((item) => (
                                    <Link
                                        key={item.rfId}
                                        to={`/shop/productdetails/${item.rfId}`}
                                        style={{ display: "flex", alignItems: "center", gap: "10px", padding: "10px", textDecoration: "none", color: "#000", borderBottom: "1px solid #eee", }}
                                        onClick={() => { setShowSearch(false); setSearch(""); }}>
                                        <img src={item.product_main_image} alt={item.product_name} style={{ width: "50px", height: "50px", objectFit: "cover", borderRadius: "5px", }} />
                                        <div>
                                            <div>{item.product_name} - {item?.product_code}</div>
                                        </div>
                                    </Link>
                                ))
                            ) : (
                                <div style={{ padding: "10px" }}>
                                    No products found
                                </div>
                            )}
                        </div>
                    )}
                </div>
                <nav className="nav-icons" style={{ display: "flex", gap: "25px", alignItems: "center" }}>
                    <Link to={token ? "/user-dashboard" : "/signin"} className={location.pathname === "/signin" ? "active" : ""} title="Account" style={{ color: "black" }}>
                        <FiUser size={22} />
                    </Link>
                    <Link to={token ? "/cart" : "/signin"} className={location.pathname === "/cart" ? "active" : ""} title="Cart" style={{ color: "black", position: "relative" }}>
                        <FiShoppingCart size={22} />
                        {cartData?.unique_items > 0 && (
                            <span style={{ position: "absolute", top: "-12px", right: "-10px", background: "#e05da3", color: "white", borderRadius: "50%", width: "25px", height: "25px", fontSize: "12px", fontWeight: "600", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                {cartData?.unique_items}
                            </span>
                        )}
                    </Link>
                </nav>
            </header>

            <header className="mobile-top-header">
                <div className="mobile-header-row">
                    <div className="mobile-logo">
                        <a href="/"><img src={Logo} /></a>
                    </div>
                    <div className="bottomlogo">
                        <img src={Bottomlogo} alt="bottom logo" />
                    </div>
                    <div className="mobile-cart">
                        <Link to={token ? "/user-dashboard" : "/signin"}>
                            <HiOutlineUser size={22} style={iconStyle} />
                        </Link>
                        <Link to={token ? "/cart" : "/signin"} style={{ position: "relative", marginLeft: "10px" }}>
                            <HiOutlineShoppingCart size={22} style={iconStyle} />
                            {Number(cartData?.unique_items) > 0 && (
                                <span className="cart-count" style={{ position: "absolute", top: "-16px", right: "-15px", background: "#e05da3", color: "white", borderRadius: "50%", width: "15px", height: "19px", fontSize: "12px", fontWeight: "600", display: "flex", alignItems: "center", justifyContent: "center" }}>{cartData.unique_items}</span>
                            )}
                        </Link>
                    </div>
                </div>
                <div>
                    <div className="mobile-search-bar">
                        <input type="text" placeholder="Search products..." value={search} onChange={(e) => searchProducts(e.target.value)} />
                        <button>
                            <FaSearch color="white" size={16} />
                        </button>
                        {showSearch && (
                            <div style={{ position: "absolute", top: "130px", left: 0, width: "100%", background: "#fff", borderRadius: "10px", boxShadow: "0 4px 10px rgba(0,0,0,0.1)", zIndex: 999, maxHeight: "350px", overflowY: "auto", }}>
                                {searchResults.length > 0 ? (
                                    searchResults.map((item) => (
                                        <Link
                                            key={item.rfId}
                                            to={`/shop/productdetails/${item.rfId}`}
                                            style={{ display: "flex", alignItems: "center", gap: "10px", padding: "10px", textDecoration: "none", color: "#000", borderBottom: "1px solid #eee", }}
                                            onClick={() => { setShowSearch(false); setSearch(""); }}>
                                            <img src={item.product_main_image} alt={item.product_name} style={{ width: "45px", height: "45px", objectFit: "cover", borderRadius: "5px", }} />
                                            <div>
                                                <div>{item.product_name} - {item?.product_code}</div>
                                            </div>
                                        </Link>
                                    ))
                                ) : (
                                    <div style={{ padding: "10px" }}>
                                        No products found
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            </header>
        </>
    );
}